import { useInfiniteQuery } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_PLAYER_FEED, USE_RETRIEVE_TEAM_FEED } from "./queryKeys";
export const useRetrieveTeamFeed = ({ team, before, limit, }) => {
    const queryKey = [
        USE_RETRIEVE_TEAM_FEED,
        team?.id,
        before?.toISOString(),
        limit,
    ];
    return useInfiniteQuery({
        queryKey,
        queryFn: async ({ pageParam }) => {
            const params = new URLSearchParams();
            params.set("limit", limit.toString());
            if (pageParam)
                params.set("before", pageParam);
            const res = await api.get(`/feed/teams/${team?.id}/?${params.toString()}`);
            return res.data;
        },
        cacheTime: CACHE_TIME,
        staleTime: STALE_TIME,
        getNextPageParam: (lastPage) => lastPage.next ?? undefined,
        enabled: !!team?.id,
    });
};
export const useRetrievePlayerFeed = ({ player, before, limit, }) => {
    const queryKey = [
        USE_RETRIEVE_PLAYER_FEED,
        player?.id,
        before?.toISOString(),
        limit,
    ];
    return useInfiniteQuery({
        queryKey,
        queryFn: async ({ pageParam }) => {
            const params = new URLSearchParams();
            params.set("limit", limit.toString());
            if (pageParam)
                params.set("before", pageParam);
            const res = await api.get(`/feed/players/${player?.id}/?${params.toString()}`);
            return res.data;
        },
        cacheTime: CACHE_TIME,
        staleTime: STALE_TIME,
        getNextPageParam: (lastPage) => lastPage.next ?? undefined,
        enabled: !!player?.id,
    });
};
